var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"research_course_warp"},[_c('FrameHeader',{attrs:{"frame":"config"}}),_c('div',{staticClass:"research_course"},[_c('iframe',{ref:_vm.uuid,staticClass:"research_course_iframe",attrs:{"src":_vm.iframeSrc}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }